import environment from "environment";
import { t } from "i18next";
import { useState } from "react";

import { BaseService } from "@ucchub/ui/src/BaseService";
import {
  CountryListRequestType,
  CountryListResponseType,
} from "@ucchub/ui/src/cloudNumbers/types/country.type";
import toArrayQueryString from "@ucchub/ui/src/utils/queryStringWithArray";

import { SelectOption } from "../../../SelectAsyncInput/SelectAsyncInput";

export type Country = Pick<
  CountryListResponseType,
  "id" | "name" | "iso2" | "iso3" | "countryCode"
>;

const useCountry = () => {
  const [countryList, setCountryList] = useState<Country[]>([]);
  const [countryOptions, setCountryOptions] = useState<SelectOption[]>([]);
  const [countryListError, setCountryListError] = useState<string>();
  const [isCountryLoading, setIsCountryLoading] = useState(false);

  const fetchCountryList = (payload?: CountryListRequestType) => {
    setIsCountryLoading(true);
    setCountryListError("");
    const query = payload ? "?" + toArrayQueryString(payload) : "";
    const apiUrl = `${environment.sharedApi.country}${query}`;
    BaseService.get<CountryListResponseType[]>(apiUrl)
      .then(({ data }) => {
        setCountryList(data);
        const countryData = data.map((country) => ({
          value: country.id,
          label: country.name,
          countryCode: country.iso2,
          icon: `/core/img/icons/flags/${country.name.toLowerCase().replace(" ", "-")}.svg`,
        }));

        setCountryOptions(countryData);
      })
      .catch(() => {
        setCountryListError(
          t("core:country:fetch_failure_country") || undefined
        );
      })
      .finally(() => {
        setIsCountryLoading(false);
      });
  };

  return {
    countryList,
    countryListError,
    isCountryLoading,
    countryOptions,
    fetchCountryList,
  };
};

export default useCountry;
